export default __webpack_public_path__ + "static/media/score.de82f684.svg";